import { getHostHub, isHostedCalendar } from 'owa-config';
import { isBootFeatureEnabled } from 'owa-metatags';

export const getCallerAppHint = (): string => {
    return isHostedCalendarApp() ? 'HostedCalendarOcpsPolicy' : 'OwaOcpsPolicy';
};

export const isHostedCalendarApp = (): boolean => {
    const hostClientType = getHostHub();
    if (!hostClientType) {
        return false;
    }
    return (
        isBootFeatureEnabled('auth-msaljs-hostedcalendar') &&
        isHostedCalendar() &&
        hostClientType == 'teamshub'
    );
};
